import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t-[3px] border-korban-gold bg-korban-navy py-10" data-testid="site-footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 text-center">
        <img src="/logo_korban_consulting.png" alt="KORBAN CONSULTING" className="h-12 w-12 rounded-full bg-white object-contain p-1" />
        <p className="text-sm text-slate-400">© 2026 KORBAN CONSULTING. Tous droits réservés.</p>
        <p className="text-xs text-slate-500">
          Yopougon, China Mall, appartement 205 — Abidjan, Côte d'Ivoire
        </p>
        <Link to="/connexion" data-testid="footer-espace-link" className="text-xs font-semibold text-korban-gold hover:underline">
          Espace personnel
        </Link>
      </div>
    </footer>
  );
}
